import { StyleSheet } from "react-native";
import { colors, fontSizes } from "../../assets/theme";

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  contentBlock: {
    paddingHorizontal: 20,
  },
  title: {
    marginBottom: 6,
    textTransform: "uppercase",
    fontSize: fontSizes.mini,
    fontFamily: "bold",
    color: colors.grayText,
  },
  workoutDate: {
    marginBottom: 12,
    fontSize: fontSizes.middle,
    fontFamily: "semibold",
    color: colors.black,
  },
  workoutContainer: {
    // marginBottom: 30,
  },
  workout: {
    alignItems: "flex-start",
    justifyContent: "space-between",
    borderRadius: 8,

    padding: 12,
    paddingBottom: 26,
    backgroundColor: colors.grayLight,
  },
  workoutTitle: {
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingBottom: 12,
    borderStyle: "solid",
    borderBottomWidth: 1,
    borderColor: colors.grayDark,
  },
  workoutName: {
    fontSize: fontSizes.small,
    fontFamily: "bold",
    color: colors.black,
  },
  workoutTimeWrap: {
    paddingHorizontal: 8,
    paddingVertical: 2,
    borderRadius: 8,
    backgroundColor: colors.grayLight_1,
  },
  workoutTime: {
    fontSize: fontSizes.mini,
    fontFamily: "semibold",
    color: colors.grayDark_1,
  },
  workoutList: {},
  workoutListItem: {
    flexDirection: "row",
  },
  workoutListItemDot: {
    paddingTop: 6,
    marginRight: 5,
    color: colors.grayDark_1,
  },
  workoutListItemText: {
    marginTop: 8,
    fontSize: fontSizes.small,
    fontFamily: "regular",
    color: colors.grayDark_1,
  },
  today: {
    fontFamily: "bold",
    fontSize: fontSizes.big,
    color: colors.black,
  },
});

export default styles;
